export default __webpack_public_path__ + "static/media/boss_tartaglia_tusk.f2fc4292.png";